import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, Modal, Card, Col, Row, Button, InputGroup, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import moment from 'moment';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import axios from 'helpers/api';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import DrugsAdminModal from './DrugsAdminModal';
import DrugsNoteModal from './DrugsNoteModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DrugsModal = ({ show, setShow, patientname, patientid, drugsdata }) => {
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [notesContent, setNotesContent] = useState('');
    const [patientName, setPatientName] = useState("");
    const [patientId, setPatientId] = useState("");
    const [drugs, setDrugsData] = useState([]);
    const [documentType, setDocumentType] = useState();
    const [cycleDetailId, setCycleDetailId] = useState();
    const [tableOpData, setTableOpData] = useState([]);
    const [showDrugsNoteModal, setShowDrugsNoteModal] = useState(false);
    const [isSaving, setIsSaving] = useState(false);


    const columns = React.useMemo(() =>
        [
            {
                accessorKey: 'rxnumber',
                header: 'Rx number',
                meta: {
                    headerProps: { className: 'text-900 text-start px-2' },
                    cellProps: { className: 'text-start px-2' }
                }
            },
            {
                accessorKey: 'drug',
                header: 'Drug',
                meta: {
                    headerProps: { className: 'text-900 text-start px-2' },
                    cellProps: { className: 'text-start px-2' }
                }
            },
            {
                accessorKey: 'refill',
                header: 'Refill',
                meta: {
                    headerProps: { className: 'text-900 text-start px-2' },
                    cellProps: { className: 'text-start px-2' }
                }
            },
            {
                accessorKey: 'previous',
                header: 'Previous Documen/notes',
                meta: {
                    headerProps: { className: 'text-900' },
                },
                cell: ({ row: { original } }) => {

                    const handleOpenDocumentOrNotes = (original) => {
                        const content = original;
                        if (content.startsWith('http')) {
                            window.open(content, '_blank');
                        } else {
                            setNotesContent(content);
                            setShowNotesModal(true);
                        }
                    };
                    return (
                        <div className="d-flex align-items-center gap-3">
                            {original.document && <FontAwesomeIcon
                                icon="eye"
                                className="text-primary cursor-pointer"
                                onClick={() => handleOpenDocumentOrNotes(original.document)}
                            />}
                            {original.notes && <FontAwesomeIcon
                                icon="file"
                                className="text-primary cursor-pointer"
                                onClick={() => handleOpenDocumentOrNotes(original.notes)}
                            />}
                        </div>
                    );
                }
            },
            // {
            //     accessorKey: 'delivered',
            //     header: 'Delivered',
            //     meta: {
            //         headerProps: { className: 'text-900 text-start ' },
            //         cellProps: { className: 'text-start' }
            //     }
            // },
            // {
            //     accessorKey: 'nxtrefill',
            //     header: 'Next Refill',
            //     meta: {
            //         headerProps: { className: 'text-900 text-start ' },
            //         cellProps: { className: 'text-start' }
            //     }
            // },
            {
                accessorKey: 'status',
                header: 'Status',
                meta: {
                    headerProps: { className: 'text-900 text-start px-2' },
                    cellProps: { className: 'text-start w-25 px-2' }
                },
                cell: ({ row: { original } }) => {
                    const lastSelectedValue = useRef(String(original.status));
                    const [isDropdownOpen, setDropdownOpen] = useState(false);
                    const handleSelectChange = (value) => {
                        handleRowData(value, "status", original.counter);
                        lastSelectedValue.current = value; // Update the last selected value
                    };

                    return (
                        <Form.Select
                            name={"cyclestatus" + original.counter}
                            value={original.status}
                            onChange={(e) => handleSelectChange(e.target.value)}
                            onClick={(e) => {
                                setTimeout(() => setDropdownOpen(document.activeElement === e.target), 100);
                                if (isDropdownOpen && (e.target.value) === lastSelectedValue.current) {
                                    handleRowData(e.target.value, "status", original.counter);
                                }
                            }}
                            size="sm"
                        >
                            <option key="Select" value="">
                                Select
                            </option>
                            <option key="dc" value="1">
                                DC
                            </option>
                            <option key="labelchange" value="2">
                                Label Change
                            </option>
                            <option key="hold" value="3">
                                Hold
                            </option>
                        </Form.Select>
                    );
                }
            },
            {
                accessorKey: 'house',
                header: 'House',
                meta: {
                    headerProps: { className: 'text-900 text-start w-25 px-2' },
                    cellProps: { className: 'text-start px-2' }
                },
                cell: ({ row: { original } }) => {
                    return <>
                        <Form.Control
                            type='number'
                            size='sm'
                            min='1'
                            max={original.refill}
                            name={"housetxt" + original.counter}
                            value={original.house ?? ''}
                            onKeyDown={(e) => {
                                if (['-', 'e', 'E', '+'].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val !== "" && Number(val) <= 0) {
                                    toast.error("Value must be greater than 0");
                                    return;
                                }
                                if (val !== "" && original.refill && Number(val) > Number(original.refill)) {
                                    toast.error(`Value cannot exceed refill remaining of ${original.refill}`);
                                    return;
                                }
                                handleRowData(val, "house", original.counter);
                            }}
                        />
                    </>
                }
            },
            {
                accessorKey: 'dayprogram',
                header: 'Program',
                meta: {
                    headerProps: { className: 'text-900 text-start w-25 px-2' },
                    cellProps: { className: 'text-start  px-2' }
                },
                cell: ({ row: { original } }) => {
                    return <>
                        <Form.Control
                            type='number'
                            size='sm'
                            min='1'
                            max={original.refill}
                            name={"daytxt" + original.counter}
                            value={original.dayprogram ?? ''}
                            onKeyDown={(e) => {
                                if (['-', 'e', 'E', '+'].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val !== "" && Number(val) <= 0) {
                                    toast.error("Value must be greater than 0");
                                    return;
                                }
                                if (val !== "" && original.refill && Number(val) > Number(original.refill)) {
                                    toast.error(`Value cannot exceed refill remaining of ${original.refill}`);
                                    return;
                                }
                                handleRowData(val, "dayprogram", original.counter);
                            }}
                        />
                    </>
                }
            },
            {
                accessorKey: 'loa',
                header: 'LOA',
                meta: {
                    headerProps: { className: 'text-900 text-start w-25 px-2' },
                    cellProps: { className: 'text-start  px-2' }
                },
                cell: ({ row: { original } }) => {
                    return <>
                        <Form.Control
                            type='number'
                            size='sm'
                            min='1'
                            max={original.refill}
                            name={"loatxt" + original.counter}
                            value={original.loa ?? ''}
                            onKeyDown={(e) => {
                                if (['-', 'e', 'E', '+'].includes(e.key)) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val !== "" && Number(val) <= 0) {
                                    toast.error("Value must be greater than 0");
                                    return;
                                }
                                if (val !== "" && original.refill && Number(val) > Number(original.refill)) {
                                    toast.error(`Value cannot exceed refill remaining of ${original.refill}`);
                                    return;
                                }
                                handleRowData(val, "loa", original.counter);
                            }}
                        />
                    </>
                }
            }

        ], []
    );

    useEffect(() => {
        setPatientName(patientname);
        setPatientId(patientid)
        filterDrugsData(drugsdata);
    }, [patientname, patientid, drugsdata]);

    const handleRowData = (gridControlValue, gridControlHeader, gridControlIndex) => {
        if (["house", "dayprogram", "loa"].includes(gridControlHeader)) {
            if (gridControlValue !== "" && gridControlValue !== null && gridControlValue !== undefined) {
                const numVal = Number(gridControlValue);
                if (numVal <= 0) {
                    toast.error("Value must be greater than 0");
                    return;
                }
                const maxRefill = drugs[gridControlIndex]?.refill;
                if (maxRefill && numVal > Number(maxRefill)) {
                    toast.error(`Value cannot exceed refill remaining of ${maxRefill}`);
                    return;
                }
            }
        }
        setDrugsData((prevDrugs) => {
            let updatedDrugs = [...prevDrugs];
            updatedDrugs[gridControlIndex] = {
                ...updatedDrugs[gridControlIndex],
                [gridControlHeader]: gridControlValue,
            };

            if (gridControlHeader === "status") {
                if (gridControlValue !== "") {
                    setDocumentType(gridControlValue);
                    setCycleDetailId(updatedDrugs[gridControlIndex].cycledetailid);
                    setShowDrugsNoteModal(true);
                }
            }
            return updatedDrugs;
        });
    };

    async function filterDrugsData(drugsdata) {

        let results = [];
        let firstrefill = drugsdata[0];
        let index = 0;

        for (let singledrugs in firstrefill) {
            results.push({
                cycledetailid: firstrefill[singledrugs].id,
                rxnumber: firstrefill[singledrugs].pharmacy_order_id,
                drug: firstrefill[singledrugs].drug,
                refill: firstrefill[singledrugs].refill_remaining,
                delivered: '',
                nxtrefill: '',
                document : firstrefill[singledrugs].change_document,
                notes: firstrefill[singledrugs].change_note,
                status: firstrefill[singledrugs].change_type,
                house: firstrefill[singledrugs].facility_qty,
                dayprogram: firstrefill[singledrugs].program_qty,
                loa: firstrefill[singledrugs].loa,
                change_type: firstrefill[singledrugs].change_type,
                counter: index++
            })
        }
        localStorage.setItem("drugmodalresults", JSON.stringify(results));
        setDrugsData(results);
    }

    const handleSave = async (e) => {
        e.preventDefault();

        let hasInvalidValue = false;
        for (let item of drugs) {
            const h = item.house !== "" && item.house !== null ? Number(item.house) : null;
            const d = item.dayprogram !== "" && item.dayprogram !== null ? Number(item.dayprogram) : null;
            const l = item.loa !== "" && item.loa !== null ? Number(item.loa) : null;
            const maxRefill = item.refill ? Number(item.refill) : null;

            if ((h !== null && h <= 0) || (d !== null && d <= 0) || (l !== null && l <= 0)) {
                hasInvalidValue = true;
                break;
            }

            if (maxRefill && ((h !== null && h > maxRefill) || (d !== null && d > maxRefill) || (l !== null && l > maxRefill))) {
                toast.error(`Quantity cannot exceed refill remaining of ${maxRefill}`);
                return;
            }
        }

        if (hasInvalidValue) {
            toast.error("Values for House, Program, and LOA must be greater than 0");
            return;
        }

        setIsSaving(true);
        try {
            let tokenStr = localStorage.getItem("accessToken");
            let drugsGridUrl = `${process.env.REACT_APP_SERVER_URL}/cycles/update-cycle-prescriptions`;

            let drugsGridData = drugs.map((arrayItem) => ({
                "cycle_detail_id": arrayItem["cycledetailid"],
                "change_type": arrayItem["status"],
                "facility_qty": arrayItem["house"] || 0,
                "program_qty": arrayItem["dayprogram"] || 0,
                "loa": arrayItem["loa"] || 0,
            }));

            let finalDrugsData = {
                "cycle_patient_id": patientId,
                "prescriptions": drugsGridData
            };

            const { data } = await axios.post(drugsGridUrl, finalDrugsData, {
                headers: { "Authorization": `Bearer ${tokenStr}` }
            });

            if (Object.keys(data).length > 0) {
                toast.success("Drug Details added successfully");
                setShow(false);
                window.location.reload();
            } else {
                toast.error("Error occurred while filling Drug Details");
            }
        } catch (error) {
            toast.error("Failed to save drug details.");
        } finally {
            setIsSaving(false);
        }
    };

    const table = useAdvanceTable({
        data: drugs,
        columns,
        selection: false,
        sortable: true,
        pagination: true,
        selectionColumnWidth: 52
    });

    return (
        <>
            <Modal show={showNotesModal} onHide={() => setShowNotesModal(false)} centered size="md">
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fs-5 fw-semibold text-primary">
                        📝 Notes
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body
                    className="px-4 py-3"
                    style={{
                        maxHeight: '400px',
                        overflowY: 'auto',
                        fontSize: '15px',
                        lineHeight: '1.6',

                        borderRadius: '0.5rem',
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {notesContent || (
                        <div className="text-center text-muted py-5">
                            No notes available.
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0">
                    <Button variant="secondary" onClick={() => setShowNotesModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                size="xl"
            >
                <Modal.Header closeButton>
                    <Modal.Title as="h5" id="copyLinkModalLabel">
                        Census for {patientName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-body-tertiary">
                    <Row>
                        <AdvanceTableProvider {...table}>
                            <Row>
                                <Col xs="12">
                                    <AdvanceTable
                                        headerClassName="bg-200 text-nowrap align-middle text-center"
                                        rowClassName="text-nowrap align-middle text-center"
                                        tableProps={{
                                            size: 'sm',
                                            striped: true,
                                            className: 'fs-10 mb-0 overflow-hidden'
                                        }}
                                    />
                                </Col>
                            </Row>
                            <Row className="p-4">
                                <Col>
                                    <AdvanceTableFooter
                                        rowInfo
                                        navButtons
                                        rowsPerPageSelection
                                    />
                                </Col>
                            </Row>
                        </AdvanceTableProvider>
                    </Row>
                    <br />
                    <Row>
                        <Col xs="8"></Col>
                        <Col xs="4">
                            <Button color="primary" className="w-100" onClick={handleSave} disabled={isSaving}>
                                {isSaving ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-2" />
                                        Saving...
                                    </>
                                ) : (
                                    "Save"
                                )}
                            </Button>
                        </Col>
                        <DrugsNoteModal show={showDrugsNoteModal} setShow={setShowDrugsNoteModal} docType={documentType} patientId={patientId} cycleDetailId={cycleDetailId} />
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
};

DrugsModal.propTypes = {
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired
};

export default DrugsModal;


